import { render, staticRenderFns } from "./MicroList.vue?vue&type=template&id=506dc484&scoped=true&"
import script from "./MicroList.vue?vue&type=script&lang=js&"
export * from "./MicroList.vue?vue&type=script&lang=js&"
import style0 from "./MicroList.vue?vue&type=style&index=0&id=506dc484&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506dc484",
  null
  
)

export default component.exports